<label class="custom-file-upload">
    <input
        #uploadInput
        [accept]="allowedMimeType"
        class="media-upload"
        type="file"
        ng2FileSelect
        [uploader]="uploader"
    />
    <mat-icon class="item-icon">cloud_upload</mat-icon>
    <span fxFlex="grow" class="tool-button-text" i18n> Upload image </span>
    <mat-icon class="qs-m" matTooltip="Upload file" i18n-matTooltip>question_mark</mat-icon>
</label>
